export default __webpack_public_path__ + "static/media/rollup.42a528ba.svg";